import { render } from "./Product.vue?vue&type=template&id=0286fa8f&scoped=true"
import script from "./Product.vue?vue&type=script&lang=js"
export * from "./Product.vue?vue&type=script&lang=js"

import "./Product.vue?vue&type=style&index=0&id=0286fa8f&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0286fa8f"],['__file',"resources/js/modules/product-categorization/components/filter/Product.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0286fa8f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0286fa8f', __exports__)) {
    api.reload('0286fa8f', __exports__)
  }
  
  module.hot.accept("./Product.vue?vue&type=template&id=0286fa8f&scoped=true", () => {
    api.rerender('0286fa8f', render)
  })

}


export default __exports__